// Optimized product categories data for better performance
// Removed redundant image URLs and optimized data structure

import { getWomenGarmentTypeIcon } from './womenGarmentTypeIcons';
import { getMenGarmentTypeIcon } from './menGarmentTypeIcons';
import { KIDS_BOY_TODDLER_PREVIEW, KIDS_GIRL_TODDLER_PREVIEW, KIDS_BOY_CATEGORY_PREVIEW, MEN_CLOTHING_CATEGORY_PREVIEW, WOMEN_CLOTHING_CATEGORY_PREVIEW } from './garmentInspirationImages';

const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=facearea&w=64&h=64&q=80";

export const PRODUCT_CATEGORIES_OPTIMIZED = [
  {
    label: "Women Clothing",
    value: "women-clothing",
    img: WOMEN_CLOTHING_CATEGORY_PREVIEW,
    types: [
      { 
        label: "Dress", 
        value: "dress", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Cocktail Dress", value: "dress-cocktail" },
          { label: "Evening Dress", value: "dress-evening" },
          { label: "Wedding Dress", value: "dress-wedding" },
          { label: "Bridal Dress", value: "dress-bridal" },
          { label: "Party Dress", value: "dress-party" },
          { label: "Casual Dress", value: "dress-casual" },
          { label: "Maxi Dress", value: "dress-maxi" },
          { label: "Midi Dress", value: "dress-midi" },
          { label: "Mini Dress", value: "dress-mini" },
          { label: "A-Line Dress", value: "dress-a-line" },
          { label: "Sheath Dress", value: "dress-sheath" },
          { label: "Wrap Dress", value: "dress-wrap" },
          { label: "Shift Dress", value: "dress-shift" },
          { label: "Bodycon Dress", value: "dress-bodycon" },
          { label: "Empire Waist Dress", value: "dress-empire-waist" },
          { label: "Designer Dress", value: "dress-designer" },
        ]
      },
      { 
        label: "Top", 
        value: "top", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Crop Top", value: "top-crop" },
          { label: "Blouse", value: "top-blouse" },
          { label: "Tunic", value: "top-tunic" },
          // { label: "Peplum Top", value: "top-peplum" },
          { label: "Off-Shoulder Top", value: "top-off-shoulder" },
          { label: "Cold Shoulder Top", value: "top-cold-shoulder" },
          { label: "Halter Top", value: "top-halter" },
          { label: "Tube Top", value: "top-tube" },
          { label: "Bardot Top", value: "top-bardot" },
          // { label: "Ruffle Top", value: "top-ruffle" },
          { label: "Lace Top", value: "top-lace" },
          { label: "Embroidered Top", value: "top-embroidered" },
          // { label: "Silk Top", value: "top-silk" },
          // { label: "Cotton Top", value: "top-cotton" },
          { label: "Designer Top", value: "top-designer" },
          { label: "Casual Top", value: "top-casual" },
        ]
      },
      { 
        label: "Skirt", 
        value: "skirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "A-Line Skirt", value: "skirt-a-line" },
          { label: "Pencil Skirt", value: "skirt-pencil" },
          { label: "Pleated Skirt", value: "skirt-pleated" },
          { label: "Maxi Skirt", value: "skirt-maxi" },
          { label: "Midi Skirt", value: "skirt-midi" },
          { label: "Mini Skirt", value: "skirt-mini" },
          { label: "Wrap Skirt", value: "skirt-wrap" },
          { label: "Tulip Skirt", value: "skirt-tulip" },
          { label: "Circle Skirt", value: "skirt-circle" },
          { label: "Gathered Skirt", value: "skirt-gathered" },
          { label: "Layered Skirt", value: "skirt-layered" },
          { label: "Ruffle Skirt", value: "skirt-ruffle" },
          { label: "Lace Skirt", value: "skirt-lace" },
          { label: "Embroidered Skirt", value: "skirt-embroidered" },
          { label: "Designer Skirt", value: "skirt-designer" },
          { label: "Casual Skirt", value: "skirt-casual" },
        ]
      },
      { 
        label: "Pant", 
        value: "jeans", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Skinny Jeans", value: "jeans-skinny" },
          { label: "Straight Leg Jeans", value: "jeans-straight-leg" },
          { label: "Bootcut Jeans", value: "jeans-bootcut" },
          { label: "Wide Leg Jeans", value: "jeans-wide-leg" },
          { label: "Flare Jeans", value: "jeans-flare" },
          { label: "Boyfriend Jeans", value: "jeans-boyfriend" },
          { label: "Mom Jeans", value: "jeans-mom" },
          { label: "High Waist Jeans", value: "jeans-high-waist" },
          { label: "Low Waist Jeans", value: "jeans-low-waist" },
          { label: "Distressed Jeans", value: "jeans-distressed" },
          { label: "Dark Wash Jeans", value: "jeans-dark-wash" },
          { label: "Light Wash Jeans", value: "jeans-light-wash" },
          { label: "Colored Jeans", value: "jeans-colored" },
          { label: "Embroidered Jeans", value: "jeans-embroidered" },
          { label: "Designer Jeans", value: "jeans-designer" },
          { label: "Casual Jeans", value: "jeans-casual" },
        ]
      },
      { 
        label: "Traditional bottoms", 
        value: "trouser", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Formal Trousers", value: "trouser-formal" },
          { label: "Chino Trousers", value: "trouser-chino" },
          { label: "Cargo Trousers", value: "trouser-cargo" },
          { label: "Pleated Trousers", value: "trouser-pleated" },
          { label: "Flat Front Trousers", value: "trouser-flat-front" },
          { label: "Wide Leg Trousers", value: "trouser-wide-leg" },
          { label: "Slim Fit Trousers", value: "trouser-slim-fit" },
          { label: "Straight Leg Trousers", value: "trouser-straight-leg" },
          { label: "Tapered Trousers", value: "trouser-tapered" },
          // { label: "Linen Trousers", value: "trouser-linen" },
          // { label: "Wool Trousers", value: "trouser-wool" },
          // { label: "Cotton Trousers", value: "trouser-cotton" },
          // { label: "Silk Trousers", value: "trouser-silk" },
          { label: "Designer Trousers", value: "trouser-designer" },
          { label: "Casual Trousers", value: "trouser-casual" },
          { label: "Business Trousers", value: "trouser-business" },
        ]
      },
      // { 
      //   label: "Blazer", 
      //   value: "blazer", 
      //   img: DEFAULT_IMAGE,
      //   subTypes: [
      //     { label: "Single Breasted Blazer", value: "blazer-single-breasted" },
      //     { label: "Double Breasted Blazer", value: "blazer-double-breasted" },
      //     { label: "Casual Blazer", value: "blazer-casual" },
      //     { label: "Formal Blazer", value: "blazer-formal" },
      //     { label: "Slim Fit Blazer", value: "blazer-slim-fit" },
      //     { label: "Regular Fit Blazer", value: "blazer-regular-fit" },
      //     { label: "Wool Blazer", value: "blazer-wool" },
      //     { label: "Linen Blazer", value: "blazer-linen" },
      //     { label: "Cotton Blazer", value: "blazer-cotton" },
      //     { label: "Velvet Blazer", value: "blazer-velvet" },
      //     { label: "Designer Blazer", value: "blazer-designer" },
      //     { label: "Colored Blazer", value: "blazer-colored" },
      //     { label: "Embroidered Blazer", value: "blazer-embroidered" },
      //     { label: "Business Blazer", value: "blazer-business" },
      //     { label: "Party Blazer", value: "blazer-party" },
      //   ]
      // },
      // { 
      //   label: "Jacket", 
      //   value: "jacket", 
      //   img: DEFAULT_IMAGE,
      //   subTypes: [
      //     { label: "Leather Jacket", value: "jacket-leather" },
      //     { label: "Denim Jacket", value: "jacket-denim" },
      //     { label: "Bomber Jacket", value: "jacket-bomber" },
      //     { label: "Track Jacket", value: "jacket-track" },
      //     { label: "Windbreaker Jacket", value: "jacket-windbreaker" },
      //     { label: "Harrington Jacket", value: "jacket-harrington" },
      //     { label: "Field Jacket", value: "jacket-field" },
      //     { label: "Suede Jacket", value: "jacket-suede" },
      //     { label: "Quilted Jacket", value: "jacket-quilted" },
      //     { label: "Designer Jacket", value: "jacket-designer" },
      //     { label: "Casual Jacket", value: "jacket-casual" },
      //     { label: "Formal Jacket", value: "jacket-formal" },
      //     { label: "Embroidered Jacket", value: "jacket-embroidered" },
      //     { label: "Party Jacket", value: "jacket-party" },
      //     { label: "Winter Jacket", value: "jacket-winter" },
      //   ]
      // },
      // { 
      //   label: "Saree", 
      //   value: "saree", 
      //   img: DEFAULT_IMAGE,
      //   subTypes: [
      //     { label: "Silk Saree", value: "saree-silk" },
      //     { label: "Cotton Saree", value: "saree-cotton" },
      //     { label: "Linen Saree", value: "saree-linen" },
      //     { label: "Georgette Saree", value: "saree-georgette" },
      //     { label: "Chiffon Saree", value: "saree-chiffon" },
      //     { label: "Crepe Saree", value: "saree-crepe" },
      //     { label: "Embroidered Saree", value: "saree-embroidered" },
      //     { label: "Zari Work Saree", value: "saree-zari-work" },
      //     { label: "Bridal Saree", value: "saree-bridal" },
      //     { label: "Wedding Saree", value: "saree-wedding" },
      //     { label: "Party Saree", value: "saree-party" },
      //     { label: "Casual Saree", value: "saree-casual" },
      //     { label: "Designer Saree", value: "saree-designer" },
      //     { label: "Traditional Saree", value: "saree-traditional" },
      //     { label: "Modern Saree", value: "saree-modern" },
      //     { label: "Festival Saree", value: "saree-festival" },
      //   ]
      // },
      { 
        label: "Lehenga", 
        value: "lehenga", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Bridal Lehenga", value: "lehenga-bridal" },
          { label: "Wedding Lehenga", value: "lehenga-wedding" },
          { label: "Party Lehenga", value: "lehenga-party" },
          { label: "Reception Lehenga", value: "lehenga-reception" },
          { label: "Sangeet Lehenga", value: "lehenga-sangeet" },
          { label: "Haldi Lehenga", value: "lehenga-haldi" },
          { label: "Mehendi Lehenga", value: "lehenga-mehendi" },
          { label: "Silk Lehenga", value: "lehenga-silk" },
          { label: "Velvet Lehenga", value: "lehenga-velvet" },
          { label: "Embroidered Lehenga", value: "lehenga-embroidered" },
          { label: "Zari Work Lehenga", value: "lehenga-zari-work" },
          { label: "Designer Lehenga", value: "lehenga-designer" },
          { label: "Traditional Lehenga", value: "lehenga-traditional" },
          { label: "Modern Lehenga", value: "lehenga-modern" },
          { label: "Indo-Western Lehenga", value: "lehenga-indo-western" },
          { label: "Festival Lehenga", value: "lehenga-festival" },
        ]
      },
      {
        label: "Blouses",
        value: "blouses",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Saree styles",
        value: "saree-styles",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Night wear",
        value: "night-wear",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Lingerie",
        value: "lingerie",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Blazer",
        value: "blazer",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Hoodies",
        value: "hoodies",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Layering",
        value: "layering",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Jacket",
        value: "jacket",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      // { 
      //   label: "Anarkali", 
      //   value: "anarkali", 
      //   img: DEFAULT_IMAGE,
      //   subTypes: [
      //     { label: "Floor Length Anarkali", value: "anarkali-floor-length" },
      //     { label: "Knee Length Anarkali", value: "anarkali-knee-length" },
      //     { label: "Calf Length Anarkali", value: "anarkali-calf-length" },
      //     { label: "Silk Anarkali", value: "anarkali-silk" },
      //     { label: "Georgette Anarkali", value: "anarkali-georgette" },
      //     { label: "Embroidered Anarkali", value: "anarkali-embroidered" },
      //     { label: "Zari Work Anarkali", value: "anarkali-zari-work" },
      //     { label: "Bridal Anarkali", value: "anarkali-bridal" },
      //     { label: "Wedding Anarkali", value: "anarkali-wedding" },
      //     { label: "Party Anarkali", value: "anarkali-party" },
      //     { label: "Casual Anarkali", value: "anarkali-casual" },
      //     { label: "Designer Anarkali", value: "anarkali-designer" },
      //     { label: "Traditional Anarkali", value: "anarkali-traditional" },
      //     { label: "Modern Anarkali", value: "anarkali-modern" },
      //     { label: "Indo-Western Anarkali", value: "anarkali-indo-western" },
      //     { label: "Festival Anarkali", value: "anarkali-festival" },
      //   ]
      // },
      { 
        label: "T-shirt", 
        value: "tshirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Round Neck T-shirt", value: "tshirt-round-neck" },
          { label: "V-Neck T-shirt", value: "tshirt-v-neck" },
          { label: "Crew Neck T-shirt", value: "tshirt-crew-neck" },
          { label: "Scoop Neck T-shirt", value: "tshirt-scoop-neck" },
          { label: "Off-Shoulder T-shirt", value: "tshirt-off-shoulder" },
          { label: "Cold Shoulder T-shirt", value: "tshirt-cold-shoulder" },
          { label: "Crop T-shirt", value: "tshirt-crop" },
          { label: "Graphic T-shirt", value: "tshirt-graphic" },
          { label: "Plain T-shirt", value: "tshirt-plain" },
          { label: "Striped T-shirt", value: "tshirt-striped" },
          { label: "Cotton T-shirt", value: "tshirt-cotton" },
          { label: "Linen T-shirt", value: "tshirt-linen" },
          { label: "Designer T-shirt", value: "tshirt-designer" },
          { label: "Casual T-shirt", value: "tshirt-casual" },
          { label: "Fitted T-shirt", value: "tshirt-fitted" },
          { label: "Oversized T-shirt", value: "tshirt-oversized" },
        ]
      },
      { 
        label: "Shirt", 
        value: "shirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Regular Collar Shirt", value: "shirt-regular-collar" },
          { label: "Spread Collar Shirt", value: "shirt-spread-collar" },
          { label: "Point Collar Shirt", value: "shirt-point-collar" },
          { label: "Button-Down Collar Shirt", value: "shirt-button-down-collar" },
          { label: "Off-Shoulder Shirt", value: "shirt-off-shoulder" },
          { label: "Cold Shoulder Shirt", value: "shirt-cold-shoulder" },
          { label: "Crop Shirt", value: "shirt-crop" },
          { label: "Peplum Shirt", value: "shirt-peplum" },
          { label: "Ruffle Shirt", value: "shirt-ruffle" },
          { label: "Lace Shirt", value: "shirt-lace" },
          { label: "Embroidered Shirt", value: "shirt-embroidered" },
          { label: "Silk Shirt", value: "shirt-silk" },
          { label: "Cotton Shirt", value: "shirt-cotton" },
          { label: "Linen Shirt", value: "shirt-linen" },
          { label: "Designer Shirt", value: "shirt-designer" },
          { label: "Casual Shirt", value: "shirt-casual" },
          { label: "Formal Shirt", value: "shirt-formal" },
        ]
      },
      {
        label: "Socks",
        value: "socks",
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Crew Socks", value: "socks-crew" },
          { label: "Ankle Socks", value: "socks-ankle" },
          { label: "No-Show Socks", value: "socks-no-show" },
          { label: "Knee-High Socks", value: "socks-knee-high" },
          { label: "Athletic Socks", value: "socks-athletic" },
          { label: "Wool Socks", value: "socks-wool" },
          { label: "Patterned Socks", value: "socks-patterned" },
          { label: "Compression Socks", value: "socks-compression" },
        ],
      },
    ],
  },
  {
    label: "Men Clothing",
    value: "men-clothing",
    img: MEN_CLOTHING_CATEGORY_PREVIEW,
    types: [
      { 
        label: "Kurta", 
        value: "kurta", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Traditional Kurta", value: "kurta-traditional" },
          { label: "Pathani Kurta", value: "kurta-pathani" },
          { label: "Indo-Western Kurta", value: "kurta-indo-western" },
          { label: "Embroidered Kurta", value: "kurta-embroidered" },
          { label: "Plain Kurta", value: "kurta-plain" },
          { label: "Silk Kurta", value: "kurta-silk" },
          { label: "Cotton Kurta", value: "kurta-cotton" },
          { label: "Linen Kurta", value: "kurta-linen" },
          { label: "Wedding Kurta", value: "kurta-wedding" },
          { label: "Festival Kurta", value: "kurta-festival" },
          { label: "Modern Kurta", value: "kurta-modern" },
          { label: "Designer Kurta", value: "kurta-designer" },
        ]
      },
      { 
        label: "Shirt", 
        value: "shirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Regular Collar - Regular Cuff", value: "shirt-regular-regular" },
          { label: "Regular Collar - French Cuff", value: "shirt-regular-french" },
          { label: "Regular Collar - Barrel Cuff", value: "shirt-regular-barrel" },
          { label: "Spread Collar - Regular Cuff", value: "shirt-spread-regular" },
          { label: "Spread Collar - French Cuff", value: "shirt-spread-french" },
          { label: "Spread Collar - Barrel Cuff", value: "shirt-spread-barrel" },
          { label: "Point Collar - Regular Cuff", value: "shirt-point-regular" },
          { label: "Point Collar - French Cuff", value: "shirt-point-french" },
          { label: "Point Collar - Barrel Cuff", value: "shirt-point-barrel" },
          { label: "Button-Down Collar - Regular Cuff", value: "shirt-button-down-regular" },
          { label: "Button-Down Collar - French Cuff", value: "shirt-button-down-french" },
          { label: "Button-Down Collar - Barrel Cuff", value: "shirt-button-down-barrel" },
        ]
      },
      { 
        label: "T-shirt", 
        value: "tshirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Round Neck T-shirt", value: "tshirt-round-neck" },
          { label: "V-Neck T-shirt", value: "tshirt-v-neck" },
          { label: "Polo T-shirt", value: "tshirt-polo" },
          { label: "Crew Neck T-shirt", value: "tshirt-crew-neck" },
          { label: "Scoop Neck T-shirt", value: "tshirt-scoop-neck" },
          { label: "Henley T-shirt", value: "tshirt-henley" },
          { label: "Graphic T-shirt", value: "tshirt-graphic" },
          { label: "Plain T-shirt", value: "tshirt-plain" },
          { label: "Striped T-shirt", value: "tshirt-striped" },
          { label: "Cotton T-shirt", value: "tshirt-cotton" },
          { label: "Linen T-shirt", value: "tshirt-linen" },
          { label: "Designer T-shirt", value: "tshirt-designer" },
        ]
      },
      { 
        label: "Trouser", 
        value: "trouser", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Formal Trousers", value: "trouser-formal" },
          { label: "Chino Trousers", value: "trouser-chino" },
          { label: "Cargo Trousers", value: "trouser-cargo" },
          { label: "Pleated Trousers", value: "trouser-pleated" },
          { label: "Flat Front Trousers", value: "trouser-flat-front" },
          { label: "Wide Leg Trousers", value: "trouser-wide-leg" },
          { label: "Slim Fit Trousers", value: "trouser-slim-fit" },
          { label: "Straight Leg Trousers", value: "trouser-straight-leg" },
          { label: "Tapered Trousers", value: "trouser-tapered" },
          { label: "Linen Trousers", value: "trouser-linen" },
          { label: "Wool Trousers", value: "trouser-wool" },
          { label: "Cotton Trousers", value: "trouser-cotton" },
        ]
      },
      { 
        label: "Blazer", 
        value: "blazer", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Single Breasted Blazer", value: "blazer-single-breasted" },
          { label: "Double Breasted Blazer", value: "blazer-double-breasted" },
          { label: "Casual Blazer", value: "blazer-casual" },
          { label: "Formal Blazer", value: "blazer-formal" },
          { label: "Slim Fit Blazer", value: "blazer-slim-fit" },
          { label: "Regular Fit Blazer", value: "blazer-regular-fit" },
          { label: "Wool Blazer", value: "blazer-wool" },
          { label: "Linen Blazer", value: "blazer-linen" },
          { label: "Cotton Blazer", value: "blazer-cotton" },
          { label: "Velvet Blazer", value: "blazer-velvet" },
          { label: "Designer Blazer", value: "blazer-designer" },
          { label: "Colored Blazer", value: "blazer-colored" },
        ]
      },
      { 
        label: "Jacket", 
        value: "jacket", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Leather Jacket", value: "jacket-leather" },
          { label: "Denim Jacket", value: "jacket-denim" },
          { label: "Bomber Jacket", value: "jacket-bomber" },
          { label: "Track Jacket", value: "jacket-track" },
          { label: "Windbreaker Jacket", value: "jacket-windbreaker" },
          { label: "Harrington Jacket", value: "jacket-harrington" },
          { label: "Field Jacket", value: "jacket-field" },
          { label: "Suede Jacket", value: "jacket-suede" },
          { label: "Quilted Jacket", value: "jacket-quilted" },
          { label: "Designer Jacket", value: "jacket-designer" },
          { label: "Casual Jacket", value: "jacket-casual" },
          { label: "Formal Jacket", value: "jacket-formal" },
        ]
      },
      { 
        label: "Waistcoat", 
        value: "waistcoat", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Single Breasted Waistcoat", value: "waistcoat-single-breasted" },
          { label: "Double Breasted Waistcoat", value: "waistcoat-double-breasted" },
          { label: "Formal Waistcoat", value: "waistcoat-formal" },
          { label: "Casual Waistcoat", value: "waistcoat-casual" },
          { label: "Wedding Waistcoat", value: "waistcoat-wedding" },
          { label: "Slim Fit Waistcoat", value: "waistcoat-slim-fit" },
          { label: "Regular Fit Waistcoat", value: "waistcoat-regular-fit" },
          { label: "Wool Waistcoat", value: "waistcoat-wool" },
          { label: "Silk Waistcoat", value: "waistcoat-silk" },
          { label: "Cotton Waistcoat", value: "waistcoat-cotton" },
          { label: "Velvet Waistcoat", value: "waistcoat-velvet" },
          { label: "Designer Waistcoat", value: "waistcoat-designer" },
        ]
      },
      { 
        label: "Dhoti", 
        value: "kurta-dhoti", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Traditional Dhoti", value: "kurta-dhoti-traditional" },
          { label: "Modern Dhoti", value: "kurta-dhoti-modern" },
          { label: "Embroidered Dhoti", value: "kurta-dhoti-embroidered" },
          { label: "Plain Dhoti", value: "kurta-dhoti-plain" },
          { label: "Silk Dhoti", value: "kurta-dhoti-silk" },
          { label: "Cotton Dhoti", value: "kurta-dhoti-cotton" },
          { label: "Linen Dhoti", value: "kurta-dhoti-linen" },
          { label: "Wedding Dhoti", value: "kurta-dhoti-wedding" },
          { label: "Festival Dhoti", value: "kurta-dhoti-festival" },
          { label: "Designer Dhoti", value: "kurta-dhoti-designer" },
          { label: "Indo-Western Dhoti", value: "kurta-dhoti-indo-western" },
          { label: "Classic Dhoti", value: "kurta-dhoti-classic" },
        ]
      },
      {
        label: "Pajama",
        value: "pajama",
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Straight Pajama", value: "pajama-straight" },
          { label: "Salwar Pajama", value: "pajama-salwar" },
          { label: "Cigarette Pajama", value: "pajama-cigarette" },
          { label: "Tapered Pajama", value: "pajama-tapered" },
          { label: "Pathani Pajama", value: "pajama-pathani" },
          { label: "Aligarh Pajama", value: "pajama-aligarh" },
          { label: "Ankle Length Pajama", value: "pajama-ankle-length" },
          { label: "Drawstring Pajama", value: "pajama-drawstring" },
          { label: "Churidar Pajama", value: "pajama-churidar" },
        ],
      },
      {
        label: "Cord Set",
        value: "cordset",
        img: DEFAULT_IMAGE,
        subTypes: [],
      },
      {
        label: "Socks",
        value: "socks",
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Crew Socks", value: "socks-crew" },
          { label: "Ankle Socks", value: "socks-ankle" },
          { label: "No-Show Socks", value: "socks-no-show" },
          { label: "Athletic Socks", value: "socks-athletic" },
          { label: "Dress Socks", value: "socks-dress" },
          { label: "Wool Socks", value: "socks-wool" },
          { label: "Compression Socks", value: "socks-compression" },
        ],
      },
    ],
  },
  {
    label: "Kids - Boy",
    value: "kids-boy",
    img: KIDS_BOY_CATEGORY_PREVIEW,
    types: [
      { 
        label: "T-shirt", 
        value: "tshirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Polo T-shirt", value: "tshirt-polo" },
          { label: "Round Neck T-shirt", value: "tshirt-round-neck" },
          { label: "V-Neck T-shirt", value: "tshirt-v-neck" },
          { label: "Collar T-shirt", value: "tshirt-collar" },
          { label: "Graphic T-shirt", value: "tshirt-graphic" },
          { label: "Striped T-shirt", value: "tshirt-striped" },
          { label: "Plain T-shirt", value: "tshirt-plain" },
          { label: "Sports T-shirt", value: "tshirt-sports" },
        ]
      },
      { 
        label: "Shirt", 
        value: "shirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Formal Shirt", value: "shirt-formal" },
          { label: "Casual Shirt", value: "shirt-casual" },
          { label: "Polo Shirt", value: "shirt-polo" },
          { label: "Oxford Shirt", value: "shirt-oxford" },
          { label: "Checked Shirt", value: "shirt-checked" },
          { label: "Striped Shirt", value: "shirt-striped" },
          { label: "Plain Shirt", value: "shirt-plain" },
        ]
      },
      { 
        label: "Shorts", 
        value: "shorts", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Cargo Shorts", value: "shorts-cargo" },
          { label: "Denim Shorts", value: "shorts-denim" },
          { label: "Cotton Shorts", value: "shorts-cotton" },
          { label: "Sports Shorts", value: "shorts-sports" },
          { label: "Casual Shorts", value: "shorts-casual" },
          { label: "Plaid Shorts", value: "shorts-plaid" },
        ]
      },
      { 
        label: "Jeans", 
        value: "jeans", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Skinny Jeans", value: "jeans-skinny" },
          { label: "Straight Leg Jeans", value: "jeans-straight-leg" },
          { label: "Slim Fit Jeans", value: "jeans-slim-fit" },
          { label: "Relaxed Fit Jeans", value: "jeans-relaxed-fit" },
          { label: "Distressed Jeans", value: "jeans-distressed" },
          { label: "Dark Wash Jeans", value: "jeans-dark-wash" },
          { label: "Light Wash Jeans", value: "jeans-light-wash" },
        ]
      },
      { 
        label: "Trousers", 
        value: "trousers", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Formal Trousers", value: "trousers-formal" },
          { label: "Chino Trousers", value: "trousers-chino" },
          { label: "Cargo Trousers", value: "trousers-cargo" },
          { label: "Cotton Trousers", value: "trousers-cotton" },
          { label: "Linen Trousers", value: "trousers-linen" },
        ]
      },
      { 
        label: "Kurta", 
        value: "kurta", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Traditional Kurta", value: "kurta-traditional" },
          { label: "Embroidered Kurta", value: "kurta-embroidered" },
          { label: "Plain Kurta", value: "kurta-plain" },
          { label: "Cotton Kurta", value: "kurta-cotton" },
          { label: "Festival Kurta", value: "kurta-festival" },
        ]
      },
      { 
        label: "Jacket", 
        value: "jacket", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Denim Jacket", value: "jacket-denim" },
          { label: "Bomber Jacket", value: "jacket-bomber" },
          { label: "Hooded Jacket", value: "jacket-hooded" },
          { label: "Sports Jacket", value: "jacket-sports" },
          { label: "Casual Jacket", value: "jacket-casual" },
        ]
      },
      { 
        label: "Sweater", 
        value: "sweater", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Pullover Sweater", value: "sweater-pullover" },
          { label: "Cardigan Sweater", value: "sweater-cardigan" },
          { label: "Hooded Sweater", value: "sweater-hooded" },
          { label: "V-Neck Sweater", value: "sweater-v-neck" },
          { label: "Turtle Neck Sweater", value: "sweater-turtle-neck" },
        ]
      },
      {
        label: "Socks",
        value: "socks",
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Crew Socks", value: "socks-crew" },
          { label: "Ankle Socks", value: "socks-ankle" },
          { label: "No-Show Socks", value: "socks-no-show" },
          { label: "Athletic Socks", value: "socks-athletic" },
          { label: "Knee-High Socks", value: "socks-knee-high" },
          { label: "Fun Pattern Socks", value: "socks-fun-pattern" },
        ],
      },
    ],
  },
  {
    label: "Kids - Girl",
    value: "kids-girl",
    img: KIDS_GIRL_TODDLER_PREVIEW,
    types: [
      { 
        label: "Dress", 
        value: "dress", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Party Dress", value: "dress-party" },
          { label: "Casual Dress", value: "dress-casual" },
          { label: "Summer Dress", value: "dress-summer" },
          { label: "Floral Dress", value: "dress-floral" },
          { label: "Tutu Dress", value: "dress-tutu" },
          { label: "Princess Dress", value: "dress-princess" },
          { label: "A-Line Dress", value: "dress-a-line" },
          { label: "Empire Waist Dress", value: "dress-empire-waist" },
        ]
      },
      { 
        label: "Frock", 
        value: "frock", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Traditional Frock", value: "frock-traditional" },
          { label: "Embroidered Frock", value: "frock-embroidered" },
          { label: "Party Frock", value: "frock-party" },
          { label: "Casual Frock", value: "frock-casual" },
          { label: "Designer Frock", value: "frock-designer" },
        ]
      },
      { 
        label: "Top", 
        value: "top", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Crop Top", value: "top-crop" },
          { label: "Tunic Top", value: "top-tunic" },
          { label: "Peplum Top", value: "top-peplum" },
          { label: "Ruffle Top", value: "top-ruffle" },
          { label: "Lace Top", value: "top-lace" },
          { label: "Embroidered Top", value: "top-embroidered" },
          { label: "Casual Top", value: "top-casual" },
          { label: "Party Top", value: "top-party" },
        ]
      },
      { 
        label: "Skirt", 
        value: "skirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "A-Line Skirt", value: "skirt-a-line" },
          { label: "Tutu Skirt", value: "skirt-tutu" },
          { label: "Pleated Skirt", value: "skirt-pleated" },
          { label: "Tiered Skirt", value: "skirt-tiered" },
          { label: "Ruffle Skirt", value: "skirt-ruffle" },
          { label: "Lace Skirt", value: "skirt-lace" },
          { label: "Embroidered Skirt", value: "skirt-embroidered" },
          { label: "Casual Skirt", value: "skirt-casual" },
        ]
      },
      { 
        label: "T-shirt", 
        value: "tshirt", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Round Neck T-shirt", value: "tshirt-round-neck" },
          { label: "V-Neck T-shirt", value: "tshirt-v-neck" },
          { label: "Graphic T-shirt", value: "tshirt-graphic" },
          { label: "Striped T-shirt", value: "tshirt-striped" },
          { label: "Plain T-shirt", value: "tshirt-plain" },
          { label: "Fitted T-shirt", value: "tshirt-fitted" },
        ]
      },
      { 
        label: "Jeans", 
        value: "jeans", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Skinny Jeans", value: "jeans-skinny" },
          { label: "Straight Leg Jeans", value: "jeans-straight-leg" },
          { label: "Slim Fit Jeans", value: "jeans-slim-fit" },
          { label: "Distressed Jeans", value: "jeans-distressed" },
          { label: "Dark Wash Jeans", value: "jeans-dark-wash" },
          { label: "Light Wash Jeans", value: "jeans-light-wash" },
        ]
      },
      { 
        label: "Shorts", 
        value: "shorts", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Denim Shorts", value: "shorts-denim" },
          { label: "Cotton Shorts", value: "shorts-cotton" },
          { label: "Sports Shorts", value: "shorts-sports" },
          { label: "Casual Shorts", value: "shorts-casual" },
          { label: "High Waist Shorts", value: "shorts-high-waist" },
        ]
      },
      { 
        label: "Sweater", 
        value: "sweater", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Pullover Sweater", value: "sweater-pullover" },
          { label: "Cardigan Sweater", value: "sweater-cardigan" },
          { label: "Hooded Sweater", value: "sweater-hooded" },
          { label: "V-Neck Sweater", value: "sweater-v-neck" },
          { label: "Turtle Neck Sweater", value: "sweater-turtle-neck" },
        ]
      },
      { 
        label: "Jacket", 
        value: "jacket", 
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Denim Jacket", value: "jacket-denim" },
          { label: "Bomber Jacket", value: "jacket-bomber" },
          { label: "Hooded Jacket", value: "jacket-hooded" },
          { label: "Casual Jacket", value: "jacket-casual" },
          { label: "Blazer Jacket", value: "jacket-blazer" },
        ]
      },
      {
        label: "Socks",
        value: "socks",
        img: DEFAULT_IMAGE,
        subTypes: [
          { label: "Crew Socks", value: "socks-crew" },
          { label: "Ankle Socks", value: "socks-ankle" },
          { label: "No-Show Socks", value: "socks-no-show" },
          { label: "Athletic Socks", value: "socks-athletic" },
          { label: "Knee-High Socks", value: "socks-knee-high" },
          { label: "Fun Pattern Socks", value: "socks-fun-pattern" },
        ],
      },
    ],
  },
];

const womenClothingCategory = PRODUCT_CATEGORIES_OPTIMIZED.find(
  (category) => category.value === 'women-clothing'
);
if (womenClothingCategory?.types?.length) {
  womenClothingCategory.types = womenClothingCategory.types.map((type) => ({
    ...type,
    img: getWomenGarmentTypeIcon(type.value) || type.img || DEFAULT_IMAGE,
  }));
}

const menClothingCategory = PRODUCT_CATEGORIES_OPTIMIZED.find(
  (category) => category.value === 'men-clothing'
);
if (menClothingCategory?.types?.length) {
  menClothingCategory.types = menClothingCategory.types.map((type) => ({
    ...type,
    img: getMenGarmentTypeIcon(type.value) || type.img || DEFAULT_IMAGE,
  }));
}

// Performance optimization: Create lookup maps for faster access
export const createCategoryLookup = () => {
  const lookup = new Map();
  PRODUCT_CATEGORIES_OPTIMIZED.forEach(category => {
    lookup.set(category.value, category);
  });
  return lookup;
};

export const createTypeLookup = (categoryValue) => {
  const category = PRODUCT_CATEGORIES_OPTIMIZED.find(cat => cat.value === categoryValue);
  if (!category) return new Map();
  
  const lookup = new Map();
  category.types.forEach(type => {
    lookup.set(type.value, type);
  });
  return lookup;
};

// Lazy loading helper for large datasets
export const getTypesChunk = (categoryValue, startIndex = 0, chunkSize = 10) => {
  const category = PRODUCT_CATEGORIES_OPTIMIZED.find(cat => cat.value === categoryValue);
  if (!category) return [];
  
  return category.types.slice(startIndex, startIndex + chunkSize);
};
